import CancelIcon from '@mui/icons-material/Cancel';
import Delete from '@mui/icons-material/Delete';
import Substituicao from '@mui/icons-material/SwapVerticalCircle';
import ThumbUpAlt from '@mui/icons-material/ThumbUpAlt';
import Warning from '@mui/icons-material/Warning';
import { Button, Chip, Dialog, DialogActions, DialogContent, DialogTitle, Tooltip, Typography } from '@mui/material';
import { grey } from '@mui/material/colors';

import IconeMagistrado from '@/img/IconeMagistrado';

import ComposicaoUtil from './ComposicaoUtil';

const estiloChipOrigemSigla = {
    marginLeft: '4px',
    height: '20px',
    fontSize: 10,
    borderColor: grey[600],
    color: grey[800]
};

export function renderChipOrigemSigla(entradaAtual) {
    if (!entradaAtual || entradaAtual.sigla === entradaAtual.siglaAdministrativa) {
        return null;
    }
    return (
        <Tooltip
            placement="top"
            title={`Será salvo no PJe como ${entradaAtual.siglaAdministrativa}.`}
        >
            <Chip
                label={`como ${entradaAtual.siglaAdministrativa}`}
                size="small"
                sx={estiloChipOrigemSigla}
                variant="outlined"
            />
        </Tooltip>
    );
}

export function renderIconeSubstituicao(magistrado) {
    return (
        <Tooltip
            placement="top"
            title={ComposicaoUtil.tooltipSubstituicao(magistrado)}
        >
            <Substituicao sx={{ fillOpacity: 0.7, color: grey[900], paddingLeft: '4px' }} />
        </Tooltip>
    );
}

export function renderAvisoMagistradoJaSubstituto(magistrado) {
    return (
        <Tooltip
            placement="top"
            title="Magistrado já é substituto"
        >
            <Warning
                sx={{
                    fill: 'darkorange',
                    display: magistrado.magistradoSubstituido && magistrado.situacaoImpedimento ? 'block' : 'none'
                }}
            />
        </Tooltip>
    );
}

export function renderCelulaSubstituto(magistrado, removerSubstituto, renderCombo) {
    return (
        <div style={{ width: '9em', display: 'flex', justifyContent: 'center' }}>
            {ComposicaoUtil.isMagistradoSubstitutoDefinido(magistrado) ? (
                <Tooltip title={magistrado.magistradoSubstituto.sigla}>
                    <Chip
                        label={magistrado.magistradoSubstituto.sigla}
                        onDelete={() => removerSubstituto(magistrado, magistrado.magistradoSubstituto)}
                        sx={{ minWidth: '10ch' }}
                    />
                </Tooltip>
            ) : (
                renderCombo()
            )}
        </div>
    );
}

export function renderBotaoRedefinirComposicao(novaComposicao, composicaoPadrao, onClick) {
    return (
        <Button
            color="inherit"
            disabled={ComposicaoUtil.mesmosMagistrados(novaComposicao, composicaoPadrao)}
            endIcon={<IconeMagistrado />}
            onClick={onClick}
            sx={{ marginLeft: '10px' }}
            title="Redefinir para composição padrão da sessão"
            variant="outlined"
        >
            Redefinir
        </Button>
    );
}

export function renderDialogRemocao({ aberto, frase, somenteOk = false, onFechar, onRemover }) {
    if (!aberto) {
        return null;
    }

    return (
        <Dialog
            maxWidth="sm"
            onClose={onFechar}
            open={aberto}
        >
            <DialogTitle>Remoção de magistrado da composição</DialogTitle>
            <DialogContent>
                <Typography>{frase}</Typography>
            </DialogContent>
            <DialogActions>
                {somenteOk ? (
                    <Button
                        color="primary"
                        endIcon={<ThumbUpAlt />}
                        onClick={onFechar}
                        variant="contained"
                    >
                        Ok
                    </Button>
                ) : (
                    <>
                        <Button
                            color="secondary"
                            endIcon={<CancelIcon />}
                            onClick={onFechar}
                            variant="outlined"
                        >
                            Cancelar
                        </Button>
                        <Button
                            color="primary"
                            endIcon={<Delete />}
                            onClick={onRemover}
                            variant="outlined"
                        >
                            Remover
                        </Button>
                    </>
                )}
            </DialogActions>
        </Dialog>
    );
}
